export const styles = {
  pad: 'PanesPad_pad',
  normal: 'PanesPad_normal',
  small: 'PanesPad_small',
  fullHeight: 'PanesPad_fullHeight',
} as const
